// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepTree-module__formBox--XPMPU {
  flex-grow: 1;
  padding: 20px;
  border-radius: 16px;
  /* -webkit-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    -moz-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);
    width: 60%; */
  width: 80%;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
}

.StepTree-module__titleBox--V2fjE > h4 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-title);
}

.StepTree-module__titleBox--V2fjE > p {
  font-size: 14px;
  margin: 0;
}

.StepTree-module__fieldBox--zn1wC {
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.StepTree-module__btnBox--k55OI {
  display: flex;
  justify-content: end;
}

.StepTree-module__colorBox--cintJ > p > span {
  font-weight: bold;
  color: var(--color-primary);
}

.StepTree-module__colorBox--cintJ {
  margin: 20px 0;
  display: flex;
  gap: 10px;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: rgb(43 93 235 / 5%);
  border-radius: 20px;
  padding: 5px;
}

.StepTree-module__colorBox--cintJ > p {
  margin: 0;
}

.StepTree-module__icon--hcfYZ > svg {
  color: var(--color-primary);
  font-size: 25px;
}

.StepTree-module__premium--XUs8M {
  display: flex;
  justify-content: center;
}

.StepTree-module__premium--XUs8M > span {
  color: var(--color-primary);
  font-size: 25px;
  font-weight: bold;
}

.StepTree-module__btnBoxUpdate--TEMyz {
  display: flex;
  justify-content: end;
}

.StepTree-module__textDownload--djds7 {
  color: var(--color-title);
  text-align: center;
}
.StepTree-module__successMessage--Cy4FF {
  display: flex;
  flex-direction: column;
  color: green;
  font-size: 30px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.StepTree-module__successMessage--Cy4FF > p {
  color: green;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}

.StepTree-module__successMessage--Cy4FF > span > svg {
  color: green;
  font-size: 90px;
}

.StepTree-module__fullWidthBox--c6irZ > div {
  width: 100%;
}

.StepTree-module__FileItemBorder--To97v {
  background-color: #e2e9ff;
  padding: 3px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px;
  border-radius: 14px;
}

.StepTree-module__FileItem--WaGJD {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px;
}

.StepTree-module__FileItemBorder--To97v > a,
.StepTree-module__FileItem--WaGJD > a {
  color: #6f879c;
  text-decoration: none;
}

.StepTree-module__infoText--MgeD2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.StepTree-module__infoText--MgeD2 > p {
  color: #4b5b69;
  font-size: 18px;
}

.StepTree-module__btnDownload--RmARa {
  display: flex;
}
.StepTree-module__filesBox--v72Xo {
  display: flex;
  gap: 20px;
  justify-content: center;
}
.StepTree-module__colorText--vPsmc {
  color: var(--color-primary);
  font-weight: 500;
}
.StepTree-module__RewieBox--LYJKE {
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
}
.StepTree-module__RewieBox--LYJKE p {
  color: var(--color-title);
  text-align: center;
}
.StepTree-module__btnBoxRewie--tSI5j {
  display: flex;
  justify-content: center;
}
.StepTree-module__gradientButton--cxvue {
  width: 100%;
  max-width: 200px;
  height: 40px;
  margin-bottom: 15px;
  margin-top: 20px;
  border-radius: 25px;
  background: linear-gradient(90deg, #0051df, #8da8ff);
  color: white !important;
  font-weight: 600;
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:active {
    transform: scale(0.98);
  }
}
@media (max-width: 950px) {
  .StepTree-module__formBox--XPMPU {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/health-ai/step-3/StepTree.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB;;;iBAGe;EACf,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;EACpD,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,0BAA0B;;EAE1B;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".formBox {\r\n  flex-grow: 1;\r\n  padding: 20px;\r\n  border-radius: 16px;\r\n  /* -webkit-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    -moz-box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    box-shadow: 0px 12px 31px -5px rgba(34, 60, 80, 0.14);\r\n    width: 60%; */\r\n  width: 80%;\r\n  margin: 0px auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.titleBox > h4 {\r\n  margin: 0 0 20px 0;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: var(--color-title);\r\n}\r\n\r\n.titleBox > p {\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n.fieldBox {\r\n  display: flex;\r\n  gap: 20px;\r\n  flex-direction: column;\r\n}\r\n\r\n.btnBox {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.colorBox > p > span {\r\n  font-weight: bold;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.colorBox {\r\n  margin: 20px 0;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-content: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  border-radius: 20px;\r\n  padding: 5px;\r\n}\r\n\r\n.colorBox > p {\r\n  margin: 0;\r\n}\r\n\r\n.icon > svg {\r\n  color: var(--color-primary);\r\n  font-size: 25px;\r\n}\r\n\r\n.premium {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.premium > span {\r\n  color: var(--color-primary);\r\n  font-size: 25px;\r\n  font-weight: bold;\r\n}\r\n\r\n.btnBoxUpdate {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.textDownload {\r\n  color: var(--color-title);\r\n  text-align: center;\r\n}\r\n.successMessage {\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: green;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 50px;\r\n}\r\n\r\n.successMessage > p {\r\n  color: green;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n}\r\n\r\n.successMessage > span > svg {\r\n  color: green;\r\n  font-size: 90px;\r\n}\r\n\r\n.fullWidthBox > div {\r\n  width: 100%;\r\n}\r\n\r\n.FileItemBorder {\r\n  background-color: #e2e9ff;\r\n  padding: 3px 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 10px;\r\n  border-radius: 14px;\r\n}\r\n\r\n.FileItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 10px;\r\n}\r\n\r\n.FileItemBorder > a,\r\n.FileItem > a {\r\n  color: #6f879c;\r\n  text-decoration: none;\r\n}\r\n\r\n.infoText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.infoText > p {\r\n  color: #4b5b69;\r\n  font-size: 18px;\r\n}\r\n\r\n.btnDownload {\r\n  display: flex;\r\n}\r\n.filesBox {\r\n  display: flex;\r\n  gap: 20px;\r\n  justify-content: center;\r\n}\r\n.colorText {\r\n  color: var(--color-primary);\r\n  font-weight: 500;\r\n}\r\n.RewieBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  justify-content: center;\r\n  margin-top: 30px;\r\n}\r\n.RewieBox p {\r\n  color: var(--color-title);\r\n  text-align: center;\r\n}\r\n.btnBoxRewie {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.gradientButton {\r\n  width: 100%;\r\n  max-width: 200px;\r\n  height: 40px;\r\n  margin-bottom: 15px;\r\n  margin-top: 20px;\r\n  border-radius: 25px;\r\n  background: linear-gradient(90deg, #0051df, #8da8ff);\r\n  color: white !important;\r\n  font-weight: 600;\r\n  border: none;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s;\r\n\r\n  &:active {\r\n    transform: scale(0.98);\r\n  }\r\n}\r\n@media (max-width: 950px) {\r\n  .formBox {\r\n    width: 80%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `StepTree-module__formBox--XPMPU`,
	"titleBox": `StepTree-module__titleBox--V2fjE`,
	"fieldBox": `StepTree-module__fieldBox--zn1wC`,
	"btnBox": `StepTree-module__btnBox--k55OI`,
	"colorBox": `StepTree-module__colorBox--cintJ`,
	"icon": `StepTree-module__icon--hcfYZ`,
	"premium": `StepTree-module__premium--XUs8M`,
	"btnBoxUpdate": `StepTree-module__btnBoxUpdate--TEMyz`,
	"textDownload": `StepTree-module__textDownload--djds7`,
	"successMessage": `StepTree-module__successMessage--Cy4FF`,
	"fullWidthBox": `StepTree-module__fullWidthBox--c6irZ`,
	"FileItemBorder": `StepTree-module__FileItemBorder--To97v`,
	"FileItem": `StepTree-module__FileItem--WaGJD`,
	"infoText": `StepTree-module__infoText--MgeD2`,
	"btnDownload": `StepTree-module__btnDownload--RmARa`,
	"filesBox": `StepTree-module__filesBox--v72Xo`,
	"colorText": `StepTree-module__colorText--vPsmc`,
	"RewieBox": `StepTree-module__RewieBox--LYJKE`,
	"btnBoxRewie": `StepTree-module__btnBoxRewie--tSI5j`,
	"gradientButton": `StepTree-module__gradientButton--cxvue`
};
export default ___CSS_LOADER_EXPORT___;
